import { Direction, GetStalledPlatformMessagesParams } from "@bvhi/backend-api";
import { Card, CardContent, GridPaginationModel, CardHeader } from "@bvhi/ui-base";
import { forwardRef, useCallback, useState } from "react";
import { StalledMessagesDataGrid } from "./stalled-messages-datagrid";

interface Props {
  direction: Direction;
  title: string;
  subheader: string;
}

export const StalledMessagesDataGridCard = forwardRef<HTMLDivElement, Props>(({ direction, title, subheader }: Props, ref) => {
  const [requestParams, setRequestParams] = useState<GetStalledPlatformMessagesParams>({
    page: 0,
    size: 25,
    direction: direction,
  });

  const updateCallback = useCallback((paginationModel: GridPaginationModel): void => {
    setRequestParams((prevParams) => ({
      ...prevParams,
      page: paginationModel.page,
      size: paginationModel.pageSize,
    }));
  }, []);

  return (
    <div ref={ref}>
      <Card sx={{ minHeight: 300 }}>
        <CardHeader restrictContentWidth={false} subheader={subheader} title={title} />
        <CardContent restrictContentWidth={false}>
          <StalledMessagesDataGrid requestParams={requestParams} updateCallback={updateCallback} />
        </CardContent>
      </Card>
    </div>
  );
});
StalledMessagesDataGridCard.displayName = "StalledMessagesDataGridCard";
